/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_Object_DescInputs */

const en_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) — Object to processing based on legitimate interest`)
};

const de_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) -- Widerspruch gegen die Verarbeitung auf Grundlage berechtigter Interessen`)
};

const fr_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) -- S'opposer au traitement fondé sur l'intérêt légitime`)
};

const es_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) -- Oponerse al tratamiento basado en interés legítimo`)
};

const it_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) — Opporsi al trattamento basato su interesse legittimo`)
};

const nl_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) — Bezwaar maken tegen verwerking op basis van gerechtvaardigd belang`)
};

const pl_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) — Sprzeciw wobec przetwarzania opartego na uzasadnionym interesie`)
};

const fi_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (artikla 21) — Vastusta oikeutettuun etuun perustuvaa käsittelyä`)
};

const da_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) — Gør indsigelse mod behandling baseret på legitim interesse`)
};

const sv_privacy_rights_item_object_desc = /** @type {(inputs: Privacy_Rights_Item_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 21) — Invända mot behandling baserad på berättigat intresse`)
};

/**
* | output |
* | --- |
* | "(Art. 21) — Object to processing based on legitimate interest" |
*
* @param {Privacy_Rights_Item_Object_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_object_desc = /** @type {((inputs?: Privacy_Rights_Item_Object_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_Object_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_object_desc(inputs)
	if (locale === "fr") return fr_privacy_rights_item_object_desc(inputs)
	if (locale === "es") return es_privacy_rights_item_object_desc(inputs)
	if (locale === "it") return it_privacy_rights_item_object_desc(inputs)
	if (locale === "nl") return nl_privacy_rights_item_object_desc(inputs)
	if (locale === "pl") return pl_privacy_rights_item_object_desc(inputs)
	if (locale === "fi") return fi_privacy_rights_item_object_desc(inputs)
	if (locale === "da") return da_privacy_rights_item_object_desc(inputs)
	if (locale === "sv") return sv_privacy_rights_item_object_desc(inputs)
	return en_privacy_rights_item_object_desc(inputs)
});